import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import Button from "@mui/material/Button";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import classes from './classes.module.scss';

import {
  createKioskPricing,
  updateKioskPricing
} from 'app/actions/kiosks';

import {
  getKioskPricings
} from 'shared/services/PriceService';

const KioskPricingForm = props => {
  const { isOpen, onClose } = props;
  const [data, setData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [itemsChanged, setItemsChanged] = useState(false);

  useEffect(() => {
    if (isOpen) {
      getKioskPricings(props.kiosk.id).then((pricings) => {
        setData(pricings);
        setOrigData(pricings);
      })
    }
  }, [isOpen]);

  useEffect(() => {
    let isChanged = false;

    if (!objectsAreSame(origData, data)) {
      isChanged = true;
    }

    setItemsChanged(isChanged);
  }, [origData, data])

  const objectsAreSame = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr2.length; i++) {
      if (arr1[i] && arr2[0]) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  }

  const handleAddRow = () => {
    const prices = [...data];
    prices.push({ store_price: 0, kiosk_id: props.kiosk.id, description: '' });
    setData(prices);
  }

  const onSubmit = async () => {
    props.onSubmit(data, origData);
  }

  const onRowEditComplete = (e) => {
    let pricing = [...data];
    let { newData, index } = e;

    pricing[index] = newData;

    setData(pricing);
  };

  const handleDeleteRow = (rowIndex) => {
    const prices = [...data];
    prices.splice(rowIndex, 1);
    setData(prices);
  }

  const priceEditor = (options) => {
    return <InputNumber value={options.value} onValueChange={(e) => options.editorCallback(e.value.toFixed(2))} minFractionDigits={2} maxFractionDigits={2} />
  };

  const textEditor = (options) => {
    return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
  };

  const footerBody = () => {
    return <div>
      <Button variant="contained" onClick={handleAddRow}>Add</Button>
    </div>
  }

  const deleteRowBody = (data, row) => {
    return <div>
      <IconButton aria-label="delete" onClick={() => handleDeleteRow(row.rowIndex)}>
        <DeleteIcon />
      </IconButton>
    </div>
  }

  let boxClass = classes.paper,
    boxStyle = null,
    headerVariant = 'h5';

  return (
    <Modal open={isOpen}
      onClose={onClose}
      className={classes.modal}>
      <Box className={boxClass} style={boxStyle}>
        <CloseIcon className={classes.closeIcon} onClick={onClose} />
        <Typography variant={headerVariant} className={classes.formTitle}>
          Manage Pricing
        </Typography>
        <hr />
        <DataTable value={data} editMode="row" footer={footerBody} onRowEditComplete={onRowEditComplete}>
          <Column field="package_id" header="Package ID" editor={(options) => textEditor(options)} style={{ width: '20%' }}></Column>
          <Column field="store_price" header="Price" editor={(options) => priceEditor(options)} style={{ width: '20%' }}></Column>
          <Column field="description" header="Description" editor={(options) => textEditor(options)} style={{ width: '20%' }}></Column>
          <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center', color: 'black' }}></Column>
          <Column body={deleteRowBody} ></Column>
        </DataTable>
        <hr />
        <Button className={classes.button} variant="contained" onClick={onClose}>Cancel</Button>
        <Button className={classes.button} variant="contained" disabled={!itemsChanged} onClick={() => onSubmit()}>Save</Button>
      </Box>
    </Modal>
  )
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, { createKioskPricing, updateKioskPricing })(KioskPricingForm);
